export const GET_CANCELED_ORDERS = 'get_canceled_orders';
export const UPDATE_CANCELED_ORDERS = 'update_canceled_orders';